import React, {Component, memo, forwardRef} from 'react';
import css from './css.css';
import identify from "~/identify";

import connectItemBar from "~/ui/ItemBar/connectItemBar";
import ItemActions from "~/ui/ItemBar/ItemActions";
import { Center, HStack, H2, Icon, IconButton, LinkToSpan, Spinner, Portal, renderHTML } from "~/native-ui";
import styled from "styled-components/native";
import CollapseText from "~/ui/ReactML/CollapseText";
import Bar from '~/components/Bar/Bar';
import { withResponsiveFlags, useResponsiveTextProps } from '~/hoc/withResponsiveProps';


const BackOrSpinner = styled(Center)`
    width: 50px
`

const Text = memo((props) => <CollapseText { ...props } fontSize="inherit" fontWeight="inherit" maxLength={40} />)

const Title = withResponsiveFlags(({ isSmallScreen, title }) => {
    return <H2 numberOfLines={1} {...useResponsiveTextProps(isSmallScreen, 370, 220)}>{title}</H2>
}, { includeKeys: ['isSmallScreen'] })

export class ItemBar extends Component {
    static propTypes = {};

    goBack = (...args) => {
        let { view, listEntries, viewEntry, itemId } = this.props;
        let action = view === (identify.VIEW_EDIT && itemId !== identify.NEW_ITEM) ? viewEntry : listEntries;

        action(...args)
    }
    

    renderBackButton() {
        return (
            <IconButton
                type="close"
                primary
                onClick={this.goBack}
            />
        );
    }

    renderMyHtml = (html) => renderHTML(html, {
        a: LinkToSpan,
        Text
    });

    renderItemTitle = () => {
        let { loading, subviewCount, itemId, trans, title, newRecordTitle } = this.props;
        const isNewRecord = itemId === identify.NEW_ITEM;
        const onlyContinue = subviewCount && isNewRecord;
        const translationProp = onlyContinue ? "modelTitleWithContinue" : "modelTitle";
        const titleHtml = isNewRecord && newRecordTitle ? newRecordTitle : this.renderMyHtml(trans(translationProp, { title }));


        return (
            <HStack space="2" className={css.titleContainer} alignItems="center">
                <BackOrSpinner className={css.titleActionContainer}>
                    {!loading ? this.renderBackButton() : <Spinner h3 className={css.loading} />}
                </BackOrSpinner>

                <Title title={ titleHtml } />
            </HStack>
        );
    };

    render() {
        return (
            <Bar
                shadow="1"
                position="sticky"
                top="0"
                zIndex="1"
                _light={{bg:"light.100"}}
                _dark={{bg:"dark.100"}}
                px="4"
                py="3"
                space="2"
                left={this.renderItemTitle()}
                right={<ItemActions {...this.props}
            />}
        />
        )
    }
}

const RXItemBar = connectItemBar(ItemBar);

export default RXItemBar;